import { useState } from 'react';
import { CreateEventRuleForm } from './create-event-rule-form.tsx';
import { CreateEventRuleDialog } from './create-event-rule-dialog.tsx';

export const CreateEventRule = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  return (
    <CreateEventRuleDialog isDialogOpen={isDialogOpen} setIsDialogOpen={setIsDialogOpen}>
      <CreateEventRuleForm onClose={handleDialogClose} />
    </CreateEventRuleDialog>
  );
};
